module.exports = __webpack_public_path__ + "static/img/bg_writenote.4fa5a8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_writenote.jpg
// module id = h7AU
// module chunks = 1